(function () {
  const root = document.getElementById('product-variants-root');
  if (!root) return;

  const tag = root.dataset.tag;
  const currentHandle = root.dataset.currentHandle;
  const currentDeviceGid = root.dataset.currentDeviceGid || null;

  if (!tag) return;

  const query = `
    query ProductsByTag($tag: String!) {
      products(first: 250, query: $tag) {
        edges {
          node {
            handle
            featuredImage {
              url(transform: { maxWidth: 160, maxHeight: 160, crop: CENTER })
              altText
            }
            device: metafield(namespace: "custom", key: "device") {
              value
            }
          }
        }
      }
    }
  `;

  const endpoint = 'https://zanae.shop/api/2026-01/graphql.json';
  const token = '15887e89e8d70805429609980c7ea24c';

  fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': token,
    },
    body: JSON.stringify({ query, variables: { tag: 'tag:' + tag } }),
  })
    .then((r) => r.json())
    .then((json) => {
      const products = (json.data?.products?.edges || []).map((e) => e.node);

      const filtered = products.filter((p) => {
        if (p.handle === currentHandle) return false;
        if (currentDeviceGid && p.device?.value !== currentDeviceGid) return false;
        return true;
      });

      if (filtered.length === 0) return;

      const grid = document.createElement('div');
      grid.className = 'product-variants-grid';

      for (const p of filtered) {
        const a = document.createElement('a');
        a.href = '/products/' + p.handle;
        a.className = 'product-variants-grid__item';

        if (p.featuredImage) {
          const img = document.createElement('img');
          img.src = p.featuredImage.url;
          img.alt = p.featuredImage.altText || p.handle;
          img.width = 80;
          img.height = 80;
          img.loading = 'lazy';
          a.appendChild(img);
        }

        grid.appendChild(a);
      }

      root.appendChild(grid);
    })
    .catch(() => {});
})();
